Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSharedValue = exports.getRelativeCoords = void 0;
exports.mockedRequestAnimationFrame = mockedRequestAnimationFrame;
var _NativeMethods = require("./NativeMethods");
var _worklet_9733178966151_init_data = {
    code: "function getRelativeCoords(parentAnimatedRef,absoluteX,absoluteY){const{measure}=this.__closure;const parentCoords=measure(parentAnimatedRef);if(parentCoords===null){return null;}return{x:absoluteX-parentCoords.x,y:absoluteY-parentCoords.y};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/utils.ts",
    sourceMap: '{"version":3,"names":["getRelativeCoords","parentAnimatedRef","absoluteX","absoluteY","measure","__closure","parentCoords","x","y"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/utils.ts"],"mappings":"AAcO,SAAAA,iBAASA,CACdC,iBAAA,CAAyCC,SACzC,CAAiBC,SACjB,CACD,OAAAC,OAAA,OAAAC,SAAA,CAEC,KAAM,CAAAC,YAAY,CAAGF,OAAO,CAACH,iBAAiB,CAAC,CAC/C,GAAIK,YAAY,GAAK,IAAI,CAAE,CACzB,MAAO,KAAI,CACb,CACA,MAAO,CACLC,CAAC,CAAEL,SAAS,CAAGI,YAAY,CAACC,CAAC,CAC7BC,CAAC,CAAEL,SAAS,CAAGG,YAAY,CAACE,CAC9B,CAAC,CACH"}',
    version: "3.5.4"
};
var getRelativeCoords = exports.getRelativeCoords = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var getRelativeCoords = function getRelativeCoords(parentAnimatedRef, absoluteX, absoluteY) {
        var parentCoords = (0, _NativeMethods.measure)(parentAnimatedRef);
        if (parentCoords === null) {
            return null;
        }
        return {
            x: absoluteX - parentCoords.x,
            y: absoluteY - parentCoords.y
        };
    };
    getRelativeCoords.__closure = {
        measure: _NativeMethods.measure
    };
    getRelativeCoords.__initData = _worklet_9733178966151_init_data;
    getRelativeCoords.__workletHash = 9733178966151;
    getRelativeCoords.__stackDetails = _e;
    return getRelativeCoords;
}();
var _worklet_7960680803966_init_data = {
    code: "function isSharedValue(value){return(value===null||value===void 0?void 0:value._isReanimatedSharedValue)===true;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/utils.ts",
    sourceMap: '{"version":3,"names":["isSharedValue","value","_isReanimatedSharedValue"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/utils.ts"],"mappings":"AA8BO,SAAAA,aAASA,CAAcC,KAAG,CAAW,CAE1C,MAAO,CAAAA,KAAK,SAALA,KAAK,iBAALA,KAAK,CAAEC,wBAAwB,IAAK,IAAI,CACjD"}',
    version: "3.5.4"
};
var isSharedValue = exports.isSharedValue = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isSharedValue = function isSharedValue(value) {
        return (value == null ? void 0 : value._isReanimatedSharedValue) === true;
    };
    isSharedValue.__closure = {};
    isSharedValue.__initData = _worklet_7960680803966_init_data;
    isSharedValue.__workletHash = 7960680803966;
    isSharedValue.__stackDetails = _e;
    return isSharedValue;
}();
function mockedRequestAnimationFrame(callback) {
    return setTimeout(function() {
        return callback(performance.now());
    }, 0);
}
